export default "__VITE_ASSET__BbpN73r___"